import { Stack } from '@libs/ui/ds'
import { useMemoSelector } from '@spa/redux/hooks'
import {
  teamsSelectors,
  usePlanningPolicies
} from '@spa/scenes/Plannings/redux/selectors'
import React from 'react'
import type { FC } from 'react'

import AddEmployeeContainer from './AddEmployeeContainer'
import CountersDropdownContainer from './CountersDropdownContainer'
import SortEmployeesContainer from './SortEmployeesContainer'

type Props = {
  teamId: number
  viewConfig?: {
    canAddMembership?: boolean
    canUpdateCounterMode?: boolean
    canSortContracts?: boolean
  }
}
export const HeaderActions: FC<Props> = ({ teamId, viewConfig = {} }) => {
  const oneTeamSelected =
    useMemoSelector(teamsSelectors.getCurrentSelectedTeams).length <= 1
  const policies = usePlanningPolicies()

  return (
    <Stack gap={1} center className='justify-center'>
      {policies.canAddMembership && viewConfig.canAddMembership && (
        <AddEmployeeContainer teamId={teamId} />
      )}
      {policies.canSortContracts &&
        viewConfig.canSortContracts &&
        oneTeamSelected && <SortEmployeesContainer teamId={teamId} />}
      {policies.canChangeCounters && viewConfig.canUpdateCounterMode && (
        <CountersDropdownContainer />
      )}
    </Stack>
  )
}
